import * as React from 'react'

import { Card } from 'tabler-react'

import { AnimationCheckSuccess } from '../Animations'

const JobApplySuccess = ({
  message,
  height,
  width
}) => (
  <Card className='margin-none'>
    <Card.Body>
      <AnimationCheckSuccess height={height} width={width} />
      <h3 className='text-center card-title'>{message}</h3>    
    </Card.Body>
  </Card>  
)

export default JobApplySuccess